import { autoinject } from "aurelia-framework";
import { PscRoutes } from "../../constants/psc/psc.constants";
import { GetPscCloseOutDocumentLinksResponse, OverridePscDetailsModel, OverridePscDetailsResponse, PscClientModel, PscInspectionModel, SavePscInspectionDeficiencyRequest, PscInspectionDeficiencyActionResponse, SavePscResponse } from "../../models/pscs/psc.models";
import { RequestClientService, ResponseType } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { AttachmentFile } from "../../models/uploader/attachmentFile";
import { DeficiencyDetails } from "../../models/pscs/deficiency-details";
import { UnitOfWorkItem } from "../../utilities/unit-of-work-observer";

@autoinject
export class PscService {

    constructor(private requestClient: RequestClientService) { }

    public getPscClientModel(id: number): Promise<PscClientModel> {
        return this.requestClient.get(`${PscRoutes.GetPscClientModel}/${id}`, {});
    }

    public getPscThumbnailZipFile(id: number): Promise<any> {
        return this.requestClient.get<Blob>(`${PscRoutes.GetPscThumbnailZipFile}/${id}`, {}, ResponseType.Blob);
    }

    public getPscCloseOutDocumentLinks(id: number): Promise<GetPscCloseOutDocumentLinksResponse> {
        return this.requestClient.get(`${PscRoutes.GetPscCloseOutDocumentLinks}/${id}`, {});
    }

    public getPsc(id: number): Promise<PscInspectionModel> {
        return this.requestClient.get(`${PscRoutes.GetPsc}/${id}`, {});
    }

    public savePsc(id: number, syncToMdm:boolean, changes: { [index: string]: UnitOfWorkItem }, cfrId:number, files: AttachmentFile[], isCloseOut: boolean = false): Promise<SavePscResponse> {
        const attachmentFiles= files.map(c=>{
            return {attachementTypeId:c.attachmentTypeId, file: c as File}
       });
        return this.requestClient.postFormData(PscRoutes.SavePsc, { id: id, cfrId: cfrId, syncToMdm:syncToMdm, changes: changes, files: attachmentFiles, isCloseOut: isCloseOut });
    }

    public changeStatus(id: number, pscStatusId: number, comments: string, meta: string, subtaskTypes: number[], misreportedReasonId: number, statusSnippet: string): Promise<void> {
        return this.requestClient.post(PscRoutes.ChangeStatus, {}, {
            id: id,
            comments: comments,
            statusId: pscStatusId,
            meta: meta,
            subtaskTypes: subtaskTypes,
            misreportedReasonId,
            statusSnippet: statusSnippet
        });
    }

    public removePsc(vesselId: number, id: string): Promise<string> {
        return this.requestClient.post<string>(PscRoutes.RemovePsc, {}, {
            id: id,
            vesselId: vesselId
        });
    }

    public getDeficiencyDetails(pscInspctionId: number): Promise<DeficiencyDetails[]> {
        return this.requestClient.get<DeficiencyDetails[]>(`${PscRoutes.GetDeficiencyDetails}/${pscInspctionId}`, {});
    }


    public activateOrDeactivateSafetyScore(id: number, isActivated: boolean): Promise<string> {
        return this.requestClient.post(PscRoutes.ActivateOrDeactivateSafetyScore, {}, {
            pscId: id,
            isActivated
        });
    }

    public updatedPscDeficiencyDetails(id: number, changes: { [index: string]: UnitOfWorkItem }): Promise<void> {
        return this.requestClient.post(PscRoutes.UpdatedPscDeficiencyDetails, {}, {
            id: id, changes: changes,
        });
    }

    public overridePscDetails(overridePscDetailsModel: OverridePscDetailsModel, attachmentFiles: AttachmentFile[]): Promise<OverridePscDetailsResponse> {
        const attachments = attachmentFiles.map(c => {
            return { file: c as File }
        });
        return this.requestClient.postFormData(PscRoutes.OverridePscDetails,
            {
                overridePscDetailsModel: overridePscDetailsModel,
                attachments: attachments
            });
    }

    public savePscInspectionDeficiency(request: SavePscInspectionDeficiencyRequest): Promise<PscInspectionDeficiencyActionResponse> {
        return this.requestClient.post(PscRoutes.UpsertPscInspectionDeficiency, {}, request);
    }

    public extractPscCloseoutDocumentsData(pscInspectionId: number): Promise<void> {
        return this.requestClient.post(`${PscRoutes.ExtractPscCloseoutDocumentsData}/${pscInspectionId}`);
    }

    public deletePscInspectionDeficiency(id: number): Promise<PscInspectionDeficiencyActionResponse> {
        return this.requestClient.delete(`${PscRoutes.RemovePscInspectionDeficiency}/${id}`, {});
    }

    public getPscSetting(): Promise<boolean> {
        return this.requestClient.get(`${PscRoutes.GetPscSetting}`);
    }
}
